module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("“Orgies are so important, and they are things "), _c('br'), _vm._v("one knows"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" nothing")]), _vm._v(" about”"), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—")]), _vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v(". ")]), _vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v(". ")]), _vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORSTER")]), _vm._v(" to P. N. Furbank, 1953")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc26b860","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/arctic-summer_00001.vue
// module id = 69
// module chunks = 0